<template>
	<div class="module_container full" style="position: relative;" v-loading="loading">
		<vxe-grid v-bind="gridOptions" :key="gridKey" v-if="gridOptions" @toolbar-button-click="toolbarButtonClickEvent"
			:ref="moduleName+'_list'">

		</vxe-grid>


		<formwindow :formConfig="formModule" v-if="formwindowShow" @back="formBack" />

	</div>
</template>
<style>

</style>
<style scoped>

</style>
<script>
	import listBase from '@_system/components/base/list.vue'
	// import { isNumber } from 'xe-utils'
	export default {
		extends: listBase,
		name: 'goodsgroupIndex',
		props: {

		},
		data() {
			return {

				loading: false,
				moduleName: 'goodsgroup',
				windowName: '商品组合',
				//windowType: 'window',
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {


		},
		components: {

		}
	}
</script>
